import { signInExistingAccountStyles } from "@WhiteCap/Overrides/Widgets/SignIn/SignInExistingAccount";
import { css } from "styled-components";


/* 
**** EC-240 - Customer Login ****
*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
signInExistingAccountStyles.userNameGridItem = {
	width: 12,
	css: css`
		label{
            font-weight: 600;
        }
	`
}

signInExistingAccountStyles.passwordGridItem = {
	width: 12,
	css: css`
		label{
            font-weight: 600;
        }
	`
}
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/